export default __webpack_public_path__ + "static/media/cancel.a9fc1671.svg";